import { getFragmentData, gql } from '@/__generated__';
import FaqCardAccordion from '@/components/FaqCard/FaqCard.Accordion';
import FaqCardAccordionItem from '@/components/FaqCard/FaqCard.AccordionItem';
import { FAQ_CARD_FRAGMENT } from '@/gql/fragments/entryCards.gql';
import { createBlock } from '@/lib/parsers/blocks';
import { excludeEmptyTypedElements } from '@liquorice/utils';
import { BlockContainer } from '../../BlockContainer';

export const FAQ_CARDS_BLOCK_FRAGMENT = gql(`
  fragment faqCardsBlock on blocks_faqCards_BlockType {
    heading
    faqMultiple {
      ...faqCard
    }
  }
`);

export const FaqCardsBlock = createBlock(FAQ_CARDS_BLOCK_FRAGMENT, ({ data, meta }) => {
  const faqMultiple = excludeEmptyTypedElements(data.faqMultiple);
  const faqCards = getFragmentData(FAQ_CARD_FRAGMENT, faqMultiple);

  return (
    <BlockContainer meta={meta} marginY>
      <FaqCardAccordion>
        {faqCards.map((card, index) => (
          <FaqCardAccordionItem key={card.id} index={index} data={card} />
        ))}
      </FaqCardAccordion>
    </BlockContainer>
  );
});

export default FaqCardsBlock;
